import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useTimer } from 'react-timer-hook';

interface TokenRefresherProps {
  expiryTimestamp: Date;
}

export function TokenRefresher(props: TokenRefresherProps) {
  const { expiryTimestamp } = props;
  const identity = useApi(identityApiRef);
  const { restart } = useTimer({ expiryTimestamp, onExpire: onExpire });
  async function onExpire() {
    // @ts-expect-error fix error on unused variable.
    const { token } = await identity.getCredentials();
    const time = new Date();
    time.setSeconds(time.getSeconds() + 30);
    // Restart timer with 30 secs
    restart(time);
  }
  return null;
}
